import { Parameter } from '@src/main/modules/parameters/domain/parameters-management/parameter.interface';

export interface ParameterEntity {
  parameterId: string;
  parameter: string;
  description: string;
  value: string | boolean;
}

export function toParameter(entity: ParameterEntity): Parameter {
  return {
    ...entity,
  };
}

export function fromParameter(model: Parameter): ParameterEntity {
  return {
    ...model,
  };
}
